/**
 * fileUrl.js
 * Accesso ai file archiviati tramite token temporaneo a scadenza breve.
 *
 * Il vecchio schema metteva il JWT di sessione in querystring: finiva nei
 * log e apriva tutto il gestionale. Ora il client chiede al backend un
 * token legato al singolo file, valido cinque minuti.
 *
 * COSA GARANTISCE, E COSA NO
 * Il token firma percorso e scadenza, niente altro. Apre un solo file,
 * per cinque minuti, e chi lo chiede resta nel registro accessi.
 * NON e' monouso: non si consuma all'apertura, non contiene l'utente, e
 * due richieste per lo stesso file nello stesso secondo danno la stessa
 * stringa. Dentro quei cinque minuti e' trasferibile. La protezione e'
 * la finestra breve piu' il fatto che apre una cosa sola, non l'unicita'
 * dell'uso.
 *
 * Poiche' ottenere il token e' una chiamata di rete, le funzioni sono
 * ASINCRONE. Per i tag <img>/<video> usare il componente <FileMedia>.
 */

import api from './api';
import { notificaErrore } from '../utils/notifiche';

/** Estrae la chiave interna da un url tipo "/uploads/pazienti/6/x.pdf". */
const chiaveDa = (url) => url.replace(/^\/?uploads\//, '');

/**
 * Restituisce un URL pronto all'uso (con token temporaneo) per un file.
 * @param {string} url  percorso pubblico o URL assoluto esterno
 * @returns {Promise<string>}
 */
export const urlFileAsync = async (url) => {
    if (!url) return url;
    // URL assoluti (Drive/S3) restano invariati
    if (/^https?:\/\//i.test(url)) return url;

    const percorso = chiaveDa(url);
    const r = await api.get('/file/token', { params: { percorso } });
    const token = r.data.data.token;
    return `/api/file/serve/${percorso}?t=${encodeURIComponent(token)}`;
};

/**
 * Apre un file in una nuova scheda dopo aver ottenuto il token.
 * Da usare al posto di <a href={urlFile(...)} target="_blank">.
 */
export const apriFile = async (url) => {
    try {
        const finale = await urlFileAsync(url);
        window.open(finale, '_blank', 'noopener,noreferrer');
    } catch (e) {
        console.error('Errore apertura file:', e);
        notificaErrore('Impossibile aprire il file.');
    }
};

export default urlFileAsync;
